import { HttpClientPlugin } from '../types';

export function createContentTypeJsonPlugin(): HttpClientPlugin {
  return {
    async beforeRequest(url, options) {
      options.headers = new Headers(options.headers);
      options.headers.append('Content-Type', 'application/json');

      if (options.json) {
        options.body = JSON.stringify(options.json);
      }

      return { url, options };
    },
  };
}
